import * as React from "react";

import {
    createStyles,
    Dialog,
    IconButton,
    InputBase,
    Paper,
    Theme,
    withStyles,
} from "@material-ui/core";

import MuiDialogContent from "@material-ui/core/DialogContent";
import { inject, observer } from "mobx-react";
import { IConfigStoreProps } from "../../stores/IConfigStoreProps";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";

import { CloseableDialogTitle } from "../shared/CloseableDialog";

import FolderOpenIcon from "@material-ui/icons/OpenInBrowser";
import { ChangeEvent } from "react";

const MEET_CACHE_KEY = "meet-teams-info";

const styles = (theme: Theme) => createStyles({
    closeButton: {
        color: theme.palette.grey[500],
        position: "absolute",
        right: theme.spacing(),
        top: theme.spacing(),
    },
    leftSmallIcon: {
        fontSize: 20,
        marginRight: theme.spacing(),
    },
    legend: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        paddingBottom: 0,
    },
    text: {
        minHeight: 96,
        width: "100%",
    },
    textField: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
        width: "100%",
    },

    divider: {
        height: 28,
        margin: 4,
    },
    iconButton: {
        padding: 10,
    },
    input: {
        flex: 1,
        marginLeft: theme.spacing(1),
    },
    inputRoot: {
        alignItems: "center",
        display: "flex",
        padding: "2px 4px",
        width: 400,
    },
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
      padding: theme.spacing(2),
    },
}))(MuiDialogContent);

interface ITeamsSearchProps {

    classes?: {
        closeButton: string;
        leftSmallIcon: string;
        legend: string;
        root: string;
        text: string;
        textField: string;

        divider: string;
        iconButton: string;
        input: string;
        inputRoot: string;
    };
    open: boolean;
    onClose: () => void;
}

interface ITeamsSearchState {
    url: string;
}

@inject(PredefinedStoreName.CONFIG)
@inject(PredefinedStoreName.CONTEXT)
@observer
class TeamsSearch extends React.Component<ITeamsSearchProps &
                                          IConfigStoreProps &
                                          IContextStoreProps, ITeamsSearchState> {

    private copyTimer?: number;

    /**
     *
     */
    constructor(props: ITeamsSearchProps & IConfigStoreProps & IContextStoreProps) {
        super(props);

        this.state = {
            url: "",
        };
    }
/**
 *
 *
 * @returns
 * @memberof ShareInvite
 */
public render() {

        return <Dialog  open={this.props.open}
                        onClose={this.props.onClose}
                        aria-labelledby="form-dialog-title">

            <CloseableDialogTitle id="form-dialog-title" onClose={this.props.onClose}>
                Open an existing Meet
            </CloseableDialogTitle>
            <DialogContent>
                { this.renderInputBox() }
            </DialogContent>

        </Dialog>;
    }

    public componentWillUnmount() {
        if (this.copyTimer) {
            clearTimeout(this.copyTimer);
        }
    }

    private renderInputBox = () => {
        const {classes} = this.props;
        return <Paper component="form" className={classes!.inputRoot}>
            <InputBase
                value={this.state.url}
                className={classes!.input}
                placeholder="a123456"
                onChange={this.handleUrlChanged}
                inputProps={{ "aria-label": "Meet code"}}
            />
            <IconButton className={classes!.iconButton}
                        aria-label="open"
                        title="Open Meet"
                        onClick={this.handleOpenMeet}
                        >
                <FolderOpenIcon  />
            </IconButton>
        </Paper>;
    }

    private handleUrlChanged = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            url: e.target.value,
        });
    }

    private handleOpenMeet = () => {
        const { hosts } = this.props.configStore!;

        const validCodePattern = /.?([\w-]{6,})$/;

        const matches = validCodePattern.exec(this.state.url);
        if (matches) {
            const code = matches[1];

            const url = `${hosts.web}/${code}`;
            localStorage.setItem(MEET_CACHE_KEY, JSON.stringify({
                joinUrl: url,
            }));
            window.location.href = url;
        }
    }
}

export default withStyles(styles, {withTheme: true})(TeamsSearch);
